import { getTypeInfo } from "credit-card-type"

/**
 * Pretty Card Numbers
 *
 * prettyCardNumber("xxxxxxxxxx343", CardType.AMERICAN_EXPRESS); // 'xxxx xxxxxx 343'
 *
 * @param {string} cardNumber
 * @param {string} cardType
 * @return {string}
 */
export function prettyCardNumber(cardNumber: string, cardType: string): string {
  const card = getTypeInfo(cardType)

  if (card) {
    const offsets = ([] as number[]).concat(0, card.gaps, cardNumber.length)
    const components: string[] = []

    for (let i = 0; offsets[i] < cardNumber.length; i++) {
      const start = offsets[i]
      const end = Math.min(offsets[i + 1], cardNumber.length)
      components.push(cardNumber.substring(start, end))
    }

    return components.join(" ")
  }

  return cardNumber
}
